// extracted by mini-css-extract-plugin
export default {"actions":"UpdateProfileData_actions__5iJoV"};